import React, { useState, useEffect } from 'react';
import '../agent_page.css'
import { getTransactionData } from '../../../controller/agent_data_controller';

export const TransactionHistoryCACS = () => {
    const [loading, setLoading] = useState(true);
    const [transactionList, setTransactionList] = useState([]);

    const fetchData = async () => {
        try {
            let result = await getTransactionData();
            setTransactionList(result);
            console.log('result:', result)
        } catch (err) {
            console.error("Error fetching:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    const formatDate = (dateString) => {
        return new Date(dateString).toLocaleDateString('en-IN', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
        });
    };

    const formatAmount = (amount) => {
        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(amount);
    };

    const getStatusColor = (status) => {
        switch (status) {
            case 'credit':
                return { color: 'green', backgroundColor: '#d4edda' };
            case 'debit':
                return { color: 'orange', backgroundColor: '#fff3cd' };
            default:
                return { color: 'gray', backgroundColor: '#e9ecef' };
        }
    };

    if (loading) {
        return <div style={{ padding: '20px 40px' }}>Loading...</div>;
    }

    return (
        <div style={{ backgroundColor: 'rgba(246, 246, 249, 1)', minHeight: '100vh' }}>
            <p className='title-demo'>Transaction History</p>
            {transactionList.length === 0 ? (
                <div style={{ padding: '20px 50px' }}>No transaction history found.</div>
            ) : (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div className='content-div-demo' style={{ marginTop: '20px', paddingBottom: '20px' }}>
                        <div style={{ display: 'flex', justifyItems: 'space-around' }}>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Transaction ID">Transaction ID</div>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Purpose">Purpose</div>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Amount">Amount</div>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Type">Type</div>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Reference ID">Reference ID</div>
                            <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title="Date">Date</div>
                        </div>
                        <hr style={{ margin: '10px 20px' }} />
                        {transactionList.map((payment, index) => (
                            <div key={payment[0]}>
                                <div style={{ display: 'flex', justifyItems: 'space-around' }}>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={payment[0]}>{payment[0]}</div>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={payment[4]}>{payment[4]}</div>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={formatAmount(payment[1])}>{formatAmount(payment[1])}</div>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        <span
                                            style={{
                                                padding: '4px 8px',
                                                borderRadius: '4px',
                                                fontSize: '12px',
                                                ...getStatusColor(payment[2])
                                            }}
                                            title={payment[2]}
                                        >
                                            {payment[2]}
                                        </span>
                                    </div>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={payment[5]}>{payment[5]}</div>
                                    <div className='request-table-item' style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={formatDate(payment[6])}>{formatDate(payment[6])}</div>
                                </div>
                                {index !== transactionList.length - 1 && <hr style={{ margin: '10px 20px' }} />}
                            </div>
                        ))}
                    </div>
                    <div style={{ height: '100px' }}></div>
                </div>
            )}
        </div>
    );
};
